// UTM / attribution params for orders. Priority: current URL → UTMify localStorage
// (utms/latest.js persists them on the landing page) → session cache. Keeps the
// seven keys UTMify's Orders API expects.
const KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "src", "sck"];

export const getUtmParams = () => {
  const out = {};
  let search = null;
  try { search = new URLSearchParams(window.location.search); } catch (e) {}
  let cached = {};
  try { cached = JSON.parse(sessionStorage.getItem("ms_utm_full") || "{}"); } catch (e) {}
  KEYS.forEach((k) => {
    let v = (search && search.get(k)) || "";
    if (!v) { try { v = localStorage.getItem(k) || ""; } catch (e) {} }
    if (!v) v = cached[k] || "";
    out[k] = String(v || "").slice(0, 200);
  });
  try {
    if (search && search.get("fbclid") && !out.utm_source) out.utm_source = "facebook";
    if (search && search.get("click_id") && !out.utm_source) out.utm_source = "kwai";
    if (Object.values(out).some(Boolean)) sessionStorage.setItem("ms_utm_full", JSON.stringify(out));
  } catch (e) {}
  return out;
};
